import { Component, OnInit } from '@angular/core';
import { PackageServiceService } from '../service/package-service.service';
import {OrderServiceService} from '../../order/order-service/order-service.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-package-view',
  templateUrl: './package-view.component.html',
  styleUrls: ['./package-view.component.css']
})
export class PackageViewComponent implements OnInit {

    itemsPerPage = 10;
    currentPage = 1;
    regExp = '';
    closeResult: string;
    packageTypeList: any = [
        { id: '1', value: 'AVAILABLE' },
        { id: '2', value: 'UNAVAILABLE' },
        { id: '3', value: 'PROVISIONED' },
        { id: '4', value: 'SHIPPED' },
        { id: '4', value: 'RETURNED' }
    ];

  constructor(private packageService: PackageServiceService, private modalService: NgbModal, private router: Router) { }
  public packageList: any = [];
  public packageHistoryList: any = [];
  public currentPackage: any;
  public noOfPackage: any;
  public loading = true;
  ngOnInit() {
    this.getAllPackages();
  }

    pageChanged(event) {
      this.currentPage = event;
      this.getAllPackages();
      console.log(event);
    }
  getAllPackagesByStatus(status){
        this.loading = true;
        this.packageService.getAllPackages(this.currentPage - 1, status, this.itemsPerPage, this.regExp, '')
        .subscribe(data => {
                const response: any = data.json();
                this.packageList = response.packages;
                this.noOfPackage = response.numberOfPackages;
                console.log(response.packages);

                this.loading = false;
                // TODO - Uncomment below code when useing actual API
                // const response: any = data;
                // if (response.status === 200) {
                //   this.userList = response.result;
                // } else {
                //   this.toastr.error('', 'Please try again');
                // }
          }, (error) => {
            this.loading = false;
            // this.toastr.error('', 'Please try again');
          });
  }
  public getAllPackages() {
    this.loading = true;
    this.packageService.getAllPackages(this.currentPage - 1, '', this.itemsPerPage, this.regExp, '')
      .subscribe(data => {
        const response: any = data.json();
        this.packageList = response.packages;
        this.noOfPackage = response.numberOfPackages;
        console.log(response.packages);

        this.loading = false;
        // TODO - Uncomment below code when useing actual API
        // const response: any = data;
        // if (response.status === 200) {
        //   this.userList = response.result;
        // } else {
        //   this.toastr.error('', 'Please try again');
        // }
      }, (error) => {
        this.loading = false;
        // this.toastr.error('', 'Please try again');
      });
  }

    onChangeStatusFilter(packageStatus) {
        console.log(packageStatus);

        if (packageStatus === 'ALL') {
            this.getAllPackages();
        } else {
            this.getAllPackagesByStatus(packageStatus);
        }
    }

    editPackage(packageId) {
        this.router.navigate( [ '/elasticcare/add/packages' ], { fragment: packageId } );
    }

    search() {
      console.log('' + this.regExp);
      this.getAllPackages();
    }

    showPackageHistory(content, pkg) {
        this.packageHistoryList = pkg.comments;
        this.currentPackage = pkg.serialNumber;
        this.modalService.open(content, {size: 'lg', ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return  `with: ${reason}`;
        }
    }

}
